import React from "react";
import { noop } from "lodash";
import { Carousel, CarouselItem } from "react-onsenui";
import "./Tutorial.css";

// const tutorialImage = (n) => (
//   require(`../assets/GIFy/gif${n}.gif`).default
// );

const tutorialScreensDB = [
  [2, 1, undefined, "buyTests"],
  [3, 2, "previousStep"],
  [4, 3, "previousStep"],
  [5, 4, "previousStep"],
  [6, 5, "previousStep"],
  [
    7,
    undefined,
    "previousStepWithoutRedirectIndex",
    undefined,
    "searchReaction"
  ]
];

export default class TutorialCarousel extends React.Component {
  state = { tutorialPage: 0 };

  handleProgressBarClick = screenIndex => {
    this.setState({ tutorialPage: screenIndex });
  };

  handleTutorialPageChange = e => {
    this.setState({ tutorialPage: e.activeIndex });
  };

  renderProgressStrip = () => {
    const pagesCount = 5;
    const width = (0.8 * 100 * this.state.tutorialPage) / pagesCount;
    return <div id="progress" style={{ width: `${width}%` }} />;
  };

  renderProgressButtons = number => {
    return (
      <button
        key={number}
        onClick={() => this.handleProgressBarClick(number - 1)}
        className={this.state.tutorialPage > number - 2 ? "filled" : "empty"}
      >
        <div className="progress-number" />
      </button>
    );
  };

  renderTutorialScreen = (
    gifn,
    redirectIndex,
    previousStep,
    buyTests,
    searchReaction
  ) => {
    const onFinish = this.props.onFinish || noop;
    return (
      <CarouselItem className="tutorial-item" key={gifn}>
        <img src={tutorialImage(gifn)} alt={`gif${gifn}`} />
        <div className="show-video clickable"><a target="blank" rel="noopener noreferrer" href="https://protestkit.eu/videos">show videos ≫</a></div>
        {redirectIndex && (
          <button
            className="tutorial-button gray-background"
            onClick={() => this.handleProgressBarClick(redirectIndex)}
          >
            Next Step
          </button>
        )}
        {buyTests && false && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://protestkit.eu"
            className="tutorial-button"
          >
            <button className="button-in-a">Buy Tests</button>
          </a>
        )}
        {searchReaction && (
          <button
            className="tutorial-button gray-background"
            onClick={onFinish.bind(this)}
          >
            {this.props.finishLabel || "Search Reaction"}
          </button>
        )}
        {previousStep && (
          <button
            className="tutorial-button"
            onClick={() => {
              if (previousStep === "previousStepWithoutRedirectIndex")
                return this.handleProgressBarClick(4);
              else return this.handleProgressBarClick(redirectIndex - 2);
            }}
          >
            Previous Step
          </button>
        )}
      </CarouselItem>
    );
  };

  render() {
    return (
      <div id="tutorial-container">
        <div id="progress-container">
          {this.renderProgressStrip()}
          {[1, 2, 3, 4, 5, 6].map(number => this.renderProgressButtons(number))}
        </div>
        <div className="spacer-div"></div>

        <Carousel
          onPostChange={this.handleTutorialPageChange.bind(this)}
          ref={carousel => {
            this.carousel = carousel;
          }}
          swipeable
          overscrollable
          autoScroll
          fullscreen
          autoScrollRatio={0.2}
          index={this.state.tutorialPage}
        >
          {tutorialScreensDB.map(screen =>
            this.renderTutorialScreen(...screen)
          )}
        </Carousel>
      </div>
    );
  }
}
